import React from 'react';
import styled, { keyframes } from "styled-components";

import { fetchConnectivityData,
         fetchTransactionsDataUS,
         fetchTransactionsDataUK,
         fetchHealthData,
         fetchPublicSectorData
         }
from '../utils/api';

import Loader from '../components/loader';

import Card from '../components/Card';

const cardEntry = keyframes`
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const DivGrid = styled.div`
  display: grid;
  grid-gap: 32px;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  grid-template-rows: auto;
}
`;

const StyledArticle = styled.article`
  padding: 0;
  margin: 0;
  animation: ${cardEntry} .8s ease 1;
  animation-delay: 0.${props => props.delay}s;
  animation-fill-mode: forwards;
  transform: translateY(80px);
  opacity: 0;
  height: 100%;
  min-height: 300px;
`;

class IndexPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      health: [],
      transactions: [],
      connectivity: [],
      publicSector: []
    }
  }

  componentDidMount() {
    fetchHealthData((posts) => {
      this.setState({
        health: posts
      });
    });

    fetchTransactionsDataUS((posts) => {
      this.setState({
        transactions: posts
      });
    });

    fetchTransactionsDataUK((posts) => {
      // console.log(posts)
      this.setState({
        transactions: this.state.transactions.concat(posts)
      });
    });

    fetchConnectivityData((posts) => {
      this.setState({
        connectivity: posts.slice(0,4)
      })
    })

    fetchPublicSectorData((posts) => {
      this.setState({
        publicSector: posts.slice(0,4)
      })
    })
  }

  render() {
    if (this.state.health.length === 0 || this.state.transactions.length === 0 || this.state.connectivity.length === 0 || this.state.publicSector === 0) {
      return <Loader />
    }

    const renderHealth = this.state.health.map((post, i) => {
      return (
      <StyledArticle key={i} delay={i}>
        <Card {...post} />
      </StyledArticle>
      )
    });
    
    const renderTransactions = this.state.transactions.map((post, i) => {
      return (
      <StyledArticle key={i} delay={i}>
        <Card {...post} />
      </StyledArticle>
      )
    });

    const renderIot = this.state.connectivity.map((post, i) => {
      return (
      <StyledArticle key={i} delay={i}>
        <Card {...post} />
      </StyledArticle>
      )
    });

    const renderPublicSector = this.state.publicSector.map((post, i) => {
      return (
      <StyledArticle key={i} delay={i}>
        <Card {...post} />
      </StyledArticle>
      )
    });

    return (
      <div>
        <h1 className="pageTitle">TRANSACTIONS</h1>
        <DivGrid>
          {renderTransactions}
        </DivGrid>
        <h1 className="pageTitle">CONNECTIVITY</h1>
        <DivGrid>
          {renderIot}
        </DivGrid>
        <h1 className="pageTitle">PUBLIC SECTOR</h1>
        <DivGrid>
          {renderPublicSector}
        </DivGrid>
        <h1 className="pageTitle">HEALTH</h1>
        <DivGrid>
          {renderHealth}
        </DivGrid>
      </div>
    )
  }
}

export default IndexPage


// WEBPACK FOOTER //
// ./src/pages/index.js